import { routePrefix as ogpPrefix } from 'ogp/settings';

const ogpCompanyPathPrefixPattern = new RegExp(`^${ogpPrefix}/[^/]+/`);

export const getOgpPathWithinCompany = (pathname: string): string =>
  pathname.replace(ogpCompanyPathPrefixPattern, '');
